<template lang="pug">
div
  v-row(align="center")
    v-col(sm="12", md="5")
      apexchart(type="area", v-bind="payableByArea")
    v-col(sm="12", md="7")
      v-row.fees-pies
        v-col
          apexchart(type="pie", v-bind="payableByPie")
        v-col
          apexchart(type="pie", v-bind="partPie")

  v-btn-toggle(borderless, mandatory, v-model="current")
    v-btn(v-for="year in years", :key="year.value", :value="year.value") {{ year.label }}

  template(v-for="table in tables")
    .headline.mt-4(v-text="partOpts[table.part]")
    v-simple-table.mt-2.fees-table
      thead
        tr(:class="{ 'all-years': current === 'all' }")
          th.text-left(
            v-for="header in headers",
            :key="header.value",
            v-text="header.label"
          )
      tbody(v-if="current === 'all'")
        tr(v-for="(fee, i) in table.fees", :key="i")
          td(v-for="header in headers", :key="header.value")
            span(v-if="header.value === 'category'", v-text="fee.category")
            v-tooltip(
              v-else-if="header.value === 'info'",
              top,
              :max-width="300",
              :open-on-hover="false",
              open-on-click
            )
              template(v-slot:activator="{ on, attrs }")
                v-btn(v-on="on", icon, @click="on.click")
                  v-icon(color="primary") mdi-information
              span(v-text="fee.info")
            span(v-else, v-text="priceFormatter(fee[header.value])")
      tbody(v-else)
        tr(v-for="(fee, i) in table.fees", :key="i")
          td(v-for="header in headers", :key="header.value")
            span(v-if="header.value === 'category'", v-text="fee.category")
            v-tooltip(
              v-else-if="header.value === 'info'",
              top,
              :max-width="300",
              :open-on-hover="false",
              open-on-click
            )
              template(v-slot:activator="{ on, attrs }")
                v-btn(v-on="on", icon, @click="on.click")
                  v-icon(color="primary") mdi-information
              span(v-text="fee.info")
            template(v-else-if="header.value === 'option'")
              span(v-if="fee.option.required") Required
              .d-flex.align-center(v-else)
                span No
                v-switch.mt-0.mx-3(
                  hide-details,
                  :input-value="fee.option.value",
                  @change="setOption($event, fee, current)"
                )
                span Yes
            template(v-else-if="header.value === 'payableBy'")
              .d-flex.align-center(v-if="fee.payableBy.editable")
                span(v-text="payableByOpts['a']")
                v-switch.mt-0.mx-3(
                  hide-details,
                  :input-value="fee.payableBy.value === 'b'",
                  @change="setPayableBy($event, fee, current)"
                )
                span(v-text="payableByOpts['b']")
              span(v-else, v-text="payableByOpts[fee.payableBy.value]")
            span(
              v-else-if="header.value === 'quantity'",
              v-text="quantityOpts[fee.quantity]"
            )
            div(
              v-else-if="header.value === 'amount'",
              style="position: relative"
            )
              span(v-text="priceFormatter(fee.amount.value)")
              transition(v-if="i === 4", name="fade")
                .pop-up(v-if="popUp.value")
                  .cont-rel.d-flex
                    v-btn.btn-close(small, icon, @click="popUp.value = false")
                      v-icon(small) mdi-close
                    .py-4.pl-4.pr-8(v-text="popUp.text")
            span(
              v-else-if="header.value === 'total'",
              v-text="priceFormatter(fee.total)"
            )
      tfoot
        tr
          th.text-left(v-for="header in headers", :key="header.value")
            template(v-if="current == 'all'")
              h2(
                v-if="header.value === 'category'",
                v-text="[partOpts[table.part], 'total'].join(' ')"
              )
              template(v-if="current == 'all'")
                span(
                  v-if="!['category', 'info'].includes(header.value)",
                  v-text="priceFormatter(table.sums[header.value])"
                )
              template(v-else)
                span(
                  v-if="header.value === 'total'",
                  v-text="priceFormatter(table.sums.total)"
                )
</template>

<script>
import deepCopy from "@/utils/deepCopy";
import fees from "./fees-new";
import { partOpts, quantityOpts, payableByOpts } from "./fees-new";

export default {
  name: "case-fees",
  data: () => ({
    current: "all",
    years: [
      { value: "all", label: "All years" },
      { value: 1, label: "1st year" },
      { value: 3, label: "3rd year" },
      { value: 4, label: "4th year" },
      { value: 6, label: "6th year" },
    ],
    popUp: {
      value: true,
      text:
        "Estimated costs. We would need to collect more information to specify the exact fee.",
    },
    numberOfEmployees: 1,
    numberOfYears: 3,
    partOpts,
    quantityOpts,
    payableByOpts,
    fees,
  }),
  methods: {
    priceFormatter(p) {
      let v = 0;
      if (p !== 0) {
        v = p.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        const [int, frac] = v.split(".");
        if (frac === "00") v = int;
      }
      return ["£", v].join("");
    },
    calculateTotal({ option, amount, quantity }) {
      if (option.value) {
        const value = amount.value;
        switch (quantity) {
          case "a":
            return value;
          case "b":
            return value * this.numberOfEmployees;
          case "c":
            return value * this.numberOfEmployees * this.numberOfYears;
          default:
        }
      } else {
        return 0;
      }
    },
    setOption(v, fee, y) {
      const { part, number, subnumber } = fee;
      let filtered = this.fees.filter(
        (item) => item.part === part && item.number === number
      );
      const el = filtered.find((item) => item.subnumber === subnumber);
      if (el) {
        el.years[y].option.value = !!v;
        if (subnumber) {
          filtered = filtered.filter((item) => item.subnumber !== subnumber);
          if (filtered.length == 1) {
            if (y !== 6 && part === "b") filtered[0].years[y].option.value = !v;
            else if (v) filtered[0].years[y].option.value = false;
          }
        }
      }
    },
    setPayableBy(v, fee, y) {
      const { part, number, subnumber } = fee;
      const el = this.fees.find(
        (fee) =>
          fee.part === part &&
          fee.number === number &&
          fee.subnumber === subnumber
      );
      if (el) el.years[y].payableBy.value = v ? "b" : "a";
    },
  },
  computed: {
    pie() {
      return {
        height: 120,
        options: {
          plotOptions: {
            pie: { dataLabels: { offset: -8, minAngleToShowLabel: 20 } },
          },
          dataLabels: { style: { fontSize: 10 } },
          legend: { position: "bottom", horizontalAlign: "right" },
          tooltip: { y: { formatter: this.priceFormatter } },
        },
      };
    },
    payableByArea() {
      const series = ["a", "b"].map((p) => ({
        name: payableByOpts[p],
        data: [1, 3, 4, 6].map((n) => {
          let total = 0;
          this.feesComputed
            .filter(
              (fee) =>
                fee.years[n] &&
                fee.years[n].option.value &&
                fee.years[n].payableBy.value === p
            )
            .forEach((fee) => {
              const t = {
                option: deepCopy(fee.years[n].option),
                amount: deepCopy(fee.amount),
                quantity: fee.quantity,
              };
              total += this.calculateTotal(t);
            });
          return parseFloat(total.toFixed(2));
        }),
      }));
      return {
        options: {
          chart: { id: "payableBy-area" },
          stroke: { curve: "straight" },
          xaxis: {
            categories: [1, 3, 4, 6],
            labels: {
              formatter: (v) =>
                `${v}${v === 1 ? "st" : v === 3 ? "rd" : "th"} year`,
            },
          },
          yaxis: { labels: { formatter: this.priceFormatter } },
          legend: { position: "top" },
          tooltip: {
            theme: "dark",
            x: { show: false },
            y: { formatter: this.priceFormatter },
          },
          dataLabels: { enabled: false },
          markers: { size: [4, 4] },
        },
        series,
      };
    },
    payableByPie() {
      let a = 0;
      let b = 0;
      this.tables.forEach((table) => {
        const y = this.current;
        const walkYear = (n) => {
          table.fees
            .filter((fee) => fee.years[n] && fee.years[n].option.value)
            .forEach((fee) => {
              const t = {
                option: deepCopy(fee.years[n].option),
                amount: deepCopy(fee.amount),
                quantity: fee.quantity,
              };
              const total = this.calculateTotal(t);
              if (fee.years[n].payableBy.value === "a") a += total;
              else b += total;
            });
        };
        if (y === "all") {
          [1, 3, 4, 6].forEach(walkYear);
        } else {
          walkYear(y);
        }
      });
      const series = [a, b].map((v) => parseFloat(v.toFixed(2)));
      return {
        options: {
          ...this.pie.options,
          labels: ["a", "b"].map((p) => payableByOpts[p]),
        },
        series,
      };
    },
    partPie() {
      let a = 0;
      let b = 0;
      this.tables.forEach((table) => {
        const y = this.current;
        const walkYear = (n) => {
          table.fees
            .filter((fee) => fee.years[n] && fee.years[n].option.value)
            .forEach((fee) => {
              const t = {
                option: deepCopy(fee.years[n].option),
                amount: deepCopy(fee.amount),
                quantity: fee.quantity,
              };
              const total = this.calculateTotal(t);
              if (table.part === "a") a += total;
              else b += total;
            });
        };
        if (y === "all") {
          [1, 3, 4, 6].forEach(walkYear);
        } else {
          walkYear(y);
        }
      });
      const series = [a, b].map((v) => parseFloat(v.toFixed(2)));
      return {
        options: {
          ...this.pie.options,
          labels: ["a", "b"].map((p) => partOpts[p]),
        },
        series,
      };
    },
    headers() {
      const columns =
        this.current === "all"
          ? [
              { label: "1st year", value: 1 },
              { label: "3rd year", value: 3 },
              { label: "4th year", value: 4 },
              { label: "6th year", value: 6 },
            ]
          : [
              { label: "Option", value: "option" },
              { label: "Payable by", value: "payableBy" },
              { label: "Quantity", value: "quantity" },
              { label: "Amount", value: "amount" },
            ];
      return [
        { label: "Category", value: "category" },
        { label: "", value: "info" },
        ...columns,
        { label: "Total", value: "total" },
      ];
    },
    feesComputed() {
      return this.fees.map((fee) => {
        const item = deepCopy(fee);
        item.amount.value =
          item.amount.value ||
          (this.numberOfEmployees < 50 ? item.amount.small : item.amount.large);
        return item;
      });
    },
    tables() {
      const y = this.current;
      const tables = ["a", "b"].map((p) => {
        let fees = this.feesComputed.filter(
          (fee) => fee.part === p && (y === "all" || fee.years[y])
        );
        let sums = {};
        if (y === "all") {
          fees = fees
            .map((fee) => {
              const item = deepCopy(fee);
              let total = 0;
              [1, 3, 4, 6].forEach((n) => {
                if (fee.years[n]) {
                  const t = {
                    option: deepCopy(item.years[n].option),
                    amount: deepCopy(item.amount),
                    quantity: item.quantity,
                  };
                  item[n] = this.calculateTotal(t);
                } else item[n] = 0;
                total += item[n];
              });
              item.total = total;
              return item;
            })
            .filter((fee) => fee.total !== 0);
          [1, 3, 4, 6].forEach((n) => {
            let s = 0;
            fees.forEach((fee) => {
              s += fee[n];
            });
            sums[n] = s;
          });
          let s = 0;
          fees.forEach((fee) => {
            s += fee.total;
          });
          sums.total = s;
        } else {
          fees = fees.map((fee) => {
            const item = deepCopy(fee);
            item.order = item.years[y].order;
            item.option = deepCopy(item.years[y].option);
            item.payableBy = deepCopy(item.years[y].payableBy);
            item.total = this.calculateTotal(item);
            return item;
          });
          fees.sort((a, b) => a.order - b.order);
          let s = 0;
          fees.forEach((fee) => {
            s += fee.total;
          });
          sums.total = s;
        }
        return { part: p, fees, sums };
      });
      return tables;
    },
  },
};
</script>

<style lang="sass">
.fees-pies
  .apexcharts-legend
    flex-direction: column
</style>

<style lang="sass" scoped>
.fees-table
  thead
    tr
      background-color: #a1e6be
      th
        border-bottom: none !important
        &:nth-child(2)
          width: 72px
        &:nth-child(3)
          width: 160px
        &:nth-child(4)
          width: 235px
        &:nth-child(5)
          width: 185px
        &:nth-child(6), &:nth-child(7)
          width: 90px
      &.all-years
        th
          &:nth-child(3), &:nth-child(4), &:nth-child(5), &:nth-child(6), &:nth-child(7)
            min-width: 152px
            width: 10%
  tbody
    tr
      td
        border-bottom: none !important

.pop-up
  $color: #f5dbede0
  $left: 40px
  z-index: 1
  position: absolute
  left: -$left
  bottom: calc(100% + 20px)
  width: 200px
  border-radius: 4px
  background-color: $color
  backdrop-filter: blur(2px)
  .cont-rel
    position: relative
    .btn-close
      position: absolute
      top: 4px
      right: 4px
    &::before
      content: ""
      position: absolute
      width: 0
      height: 0
      top: 100%
      left: $left
      border-left: 20px solid transparent
      border-right: 20px solid transparent
      border-top: 20px solid $color
</style>